import type { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { InlineIcon } from './inline-icon';

interface BannerProps {
  text?: string;
  icon?: string;
}

export const Banner: FC<BannerProps> = (props) => {
  const { text, icon = 'fa6-solid:helmet-safety' } = props;

  if (text)
    return (
      <Box
        sx={{
          py: 1,
          px: 2,
          bgcolor: 'warning.main',
          color: 'warning.contrastText',
          justifyContent: 'center',
          display: 'flex',
          // overlap menu
          zIndex: 9999
        }}
      >
        <Typography
          variant="overline"
          sx={{ lineHeight: '1.5em' }}
        >
          <InlineIcon icon={icon} />
          {text}
        </Typography>
      </Box>
    );

  return null;
};
